import CardBase from "./CardBase";

export default CardBase;
